import React, { forwardRef, useRef, useState } from 'react';

import { IconButton, useTheme } from '@material-ui/core';
import { VerticalTimelineElement } from 'react-vertical-timeline-component';
import { MdDeleteOutline, MdOutlineEdit, MdRemoveRedEye } from 'react-icons/md';

import { classes, renderElement } from 'utils';
import { Orderer, Tooltip } from 'components';
import helpers from './helpers';

import styles from './TimeLineElement.module.scss';

const TimeLineElement = forwardRef((props, ref) => {
  const { data, index, dispatch } = props;
  const [visible, setVisible] = useState(false);

  const theme = useTheme();
  const highlight = useRef(false);
  highlight.current = props.highlight && (visible || highlight.current);

  const helper = helpers[data.type];

  if (!helper) {
    return null;
  }

  const { type, seconds } = data;
  const color = theme.palette.primary.main;
  const iconStyle = { background: '#fff', color, boxShadow: `0 0 0 4px ${color}` };

  const renderMessageActions = () => {
    const button = (Icon, hint, action) => (
      <IconButton onClick={() => dispatch({ type: action, payload: index })} size="small">
        <Tooltip title={hint} placement="top">
          <Icon />
        </Tooltip>
      </IconButton>
    );

    return (
      <div className={styles.actions}>
        {button(MdDeleteOutline, 'Delete message', 'DELETE_MESSAGE')}
        {button(MdOutlineEdit, 'Edit message', 'SHOW_EDIT_MESSAGE_DIALOG')}

        {type === 'interaction'
          ? button(MdRemoveRedEye, 'Preview interaction', 'SHOW_PREVIEW_INTERACTION')
          : null}
      </div>
    );
  };

  return (
    <div
      ref={ref}
      className={classes(
        styles.element,
        highlight.current ? styles.highlight : '',
        visible ? styles.visible : ''
      )}
    >
      <VerticalTimelineElement
        date={`${seconds} ${seconds > 1 ? 'seconds' : 'second'}`}
        dateClassName={styles.date}
        iconStyle={{ ...iconStyle, ...(helper.iconStyle || {}) }}
        icon={renderElement(helper.icon)}
        intersectionObserverProps={{
          rootMargin: '0px 0px 40px 0px',
          onChange: visible => setVisible(visible),
        }}
      >
        <div className={styles.bg} />
        <div className={styles.messageContent}>{helper.renderMessage(data)}</div>

        {renderMessageActions()}

        <div className={styles.orderer}>
          <Orderer
            value={index + 1}
            min={1}
            max={props.numMessages}
            onChange={newPos =>
              dispatch({
                type: 'CHANGE_POSITION',
                payload: { currentPos: index, newPos: newPos - 1 },
              })
            }
          />
        </div>
      </VerticalTimelineElement>
    </div>
  );
});

export default TimeLineElement;
